import { render, staticRenderFns } from "./SBoxStemdoerExperience.vue?vue&type=template&id=2afa7f64&scoped=true"
import script from "./sBoxStemdoerExperience.ts?vue&type=script&lang=ts&external"
export * from "./sBoxStemdoerExperience.ts?vue&type=script&lang=ts&external"
import style0 from "./SBoxStemdoerExperience.vue?vue&type=style&index=0&id=2afa7f64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa7f64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2afa7f64')) {
      api.createRecord('2afa7f64', component.options)
    } else {
      api.reload('2afa7f64', component.options)
    }
    module.hot.accept("./SBoxStemdoerExperience.vue?vue&type=template&id=2afa7f64&scoped=true", function () {
      api.rerender('2afa7f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-box-stemdoer-experience/SBoxStemdoerExperience.vue"
export default component.exports